import React from 'react';
import { Logo } from './Logo';
import { LanguageToggle } from './LanguageToggle';
import { useLanguage } from '../hooks/useLanguage';
import { business, footerLinks } from '../data/business';
import { ui } from '../data/translations';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="w-full bg-navy-deep pb-24 pt-16 text-white md:pb-10" data-id="element-75" data-mp="36ooaxlvzlpwd">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 md:grid-cols-3 lg:px-8" data-id="element-76" data-mp="3ufa6idot1hph">
        <div data-id="element-77" data-mp="38qw2zmvrtrp">
          <Logo data-id="element-78" data-mp="38h3r5ed5aiu" />
          <p className="mt-4 max-w-xs text-sm text-white/65" data-id="element-79" data-mp="38zbozae1d6l">{t(ui.footer.tagline)}</p>
          <a href="#contact" className="mt-6 inline-flex h-12 items-center whitespace-nowrap rounded-md bg-gold px-5 font-display text-sm font-semibold text-navy-deep transition-colors duration-150 hover:bg-gold-dark" data-id="element-80" data-mp="3levgj10wbefn">
            {t(ui.cta.estimate)}
          </a>
        </div>

        <nav aria-label="Footer" data-id="element-81" data-mp="2eyjoziskwut1">
          <h2 className="font-display text-sm font-semibold text-gold" data-id="element-82" data-mp="2ezl5i2sd69i5">{t(ui.footer.quickLinks)}</h2>
          <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2.5" data-id="element-83" data-mp="3l9sin4pzgsoh">
            {footerLinks.map(link => <li key={link.label.en} data-id="element-84" data-mp="3gcjw6rxsy2hf">
                <a href={link.href} className="text-sm text-white/75 transition-colors duration-150 hover:text-white" data-id="element-85" data-mp="3v7zxni0pp0nu">
                  {t(link.label)}
                </a>
              </li>)}
          </ul>
        </nav>

        <div data-id="element-86" data-mp="81fqhygiyw59">
          <h2 className="font-display text-sm font-semibold text-gold" data-id="element-87" data-mp="80xjq7w8kzj3">{t(ui.footer.contact)}</h2>
          <ul className="mt-4 space-y-2.5 text-sm text-white/75" data-id="element-88" data-mp="33nogbm61tnc">
            <li data-id="element-89" data-mp="hrs75fl7y564">
              <a href={business.phoneHref} className="font-display text-xl font-bold text-white hover:text-gold" data-id="element-90" data-mp="hsaeb79f63st">
                {business.phoneDisplay}
              </a>
            </li>
            <li data-id="element-91" data-mp="qub9zzp08hsd">{t(business.serviceArea)}</li>
            <li data-id="element-92" data-mp="mrwpzc9lnbzi">{t(business.hours)}</li>
          </ul>
          <div className="mt-6" data-id="element-93" data-mp="mt7pv0zxbzlc">
            <LanguageToggle data-id="element-94" data-mp="mq3ftmzs29mr" />
          </div>
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-7xl border-t border-white/10 px-5 pt-6 lg:px-8" data-id="element-95" data-mp="two2jpj5v957">
        <p className="text-xs text-white/50" data-id="element-96" data-mp="yuzdk3l6zpp0">
          © {new Date().getFullYear()} {business.name}. {t(ui.footer.rights)}
        </p>
      </div>
    </footer>;
}